import React from 'react';
import ReactDOM from 'react-dom';
import App from './app/containers/App';
import * as serviceWorker from './serviceWorker';

//IMPORT STYLES 
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/scss/reset.scss';
import './assets/scss/colors.scss';
import './assets/scss/app.scss';
import './assets/scss/form.scss';
import './assets/scss/toast.scss';

const appHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty("--app-height", `${window.innerHeight - 50}px`);
};
window.addEventListener("resize", appHeight);
appHeight();

ReactDOM.render(<App />, document.getElementById('root'));

// register service workers
serviceWorker.register();
